import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationYesNoPluginService } from './yes-no.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from '../../../modal/modal.component';
import * as _ from 'lodash';
import { ConfirmComponent } from '../../../modal/confirm.component';

@Component({
  selector: 'yes-no-edit',
  templateUrl: './yes-no-edit.component.html',
  standalone: false
})
export class InstallationYesNoEditPageComponent extends BaseInstallationEditPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  applyAllStatus: number = null;

  public statuses = [];
  public currentItem: any;
  public isApplyAllSelectorOpen = false;
  private questionToRemove: number;

  private sub = new Subscription();

  @ViewChild('statusesModal', { static: true }) statusesModal: ModalComponent;
  @ViewChild('questionDeleteConfirm', { static: true }) questionDeleteConfirm: ConfirmComponent;
  machine: any;
  customer: any;
  bobst: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationYesNoPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['questions'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateYesNo(this.inspectionId, this.pointId, this.pluginId, model.questions).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['questions'];
    control.push(this.initQuestion());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['questions'];
    control.removeAt(this.questionToRemove);
  }

  public selectStatusesMenu(item: any) {
    if (this.isApplyAllSelectorOpen) {
      const selectedIndex = this.applyAllStatus === item.selectedIndex ? '' : item.selectedIndex;
      this.applyAllStatus = selectedIndex;
      const control = <UntypedFormArray>this.editForm.controls['questions'];
      _.forEach(control.controls, (question: UntypedFormGroup) => {
        question.controls['Status'].setValue(selectedIndex);
      });
      return;
    }

    const selectedIndex = this.currentItem.controls['Status'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Status'].setValue(selectedIndex);
  }

  public openStatusSelector(selectedIndex: number, i: number): void {
    this.isApplyAllSelectorOpen = false;
    this.openSelector(this.statusesModal, this.statuses, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['questions'];
    this.currentItem = control.controls[i];
  }

  public openApplyAllStatusSelector(): void {
    this.isApplyAllSelectorOpen = true;
    this.currentItem = null;
    this.openSelector(this.statusesModal, this.statuses, this.applyAllStatus || this.applyAllStatus === 0 ? this.applyAllStatus : -1);
  }

  public onClose(e: any) {
    if (this.isApplyAllSelectorOpen) {
      const control = <UntypedFormArray>this.editForm.controls['questions'];
      _.forEach(control.controls, (question: UntypedFormGroup) => {
        question.controls['Status'].markAsTouched();
      });
      this.isApplyAllSelectorOpen = false;
      return;
    }

    this.currentItem.controls['Status'].markAsTouched();
  }

  public openQuestionDeleteConfirm(i: number) {
    this.questionDeleteConfirm.open();
    this.questionToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.statuses = this.pluginService.getStatuses();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      if (!this.plugin.config.Questions?.length) {
        this.plugin.config.Questions = this.plugin.config.YesNo ? [this.plugin.config.YesNo] : [];
        this.plugin.config.YesNo = null;
      }
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      questions: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['questions'];
    _.forEach(this.plugin.config.Questions, (el) => {
      control.push(this.initQuestion(el));
    });
  }

  private initQuestion(el?: any) {
    return this.fb.group({
      Label: new UntypedFormControl(el?.Label ?? ''),
      Status: new UntypedFormControl(el?.Status ? parseInt(el.Status) : null)
    });
  }
}
